'use client';

import { useAuth } from '@/context/AuthContext';

/**
 * Returns the user's configured timezone, falling back to America/New_York.
 * Use this to pass timezone to formatDate(), timeAgo(), formatDateTime(), etc.
 */
export function useTimezone(): string {
  const { user } = useAuth();
  return user?.timezone || 'America/New_York';
}
